import moment from 'moment';

export const formatDateShort = (date: string) => moment(date).format('MMM D');
